import script from "./AddSurvey.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSurvey.vue?vue&type=script&setup=true&lang=js"

import "./AddSurvey.vue?vue&type=style&index=0&id=1820e2ea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1820e2ea"]])

export default __exports__